import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { FaUser, FaUserTie, FaCalendarAlt } from 'react-icons/fa';
import { GrDocumentVerified } from 'react-icons/gr';
import CustomSearchBar from '../../../../../Components/custom_components/CustomSearchBar/CustomSearchBar';
import CustomTooltipWithoutRoundBorder from '../../../../../Components/CustomActionButtonWithTooltip/CustomTooltipWithoutRoundBorder';
import CustomModal from '../../../../../Components/custom_components/CustomModal/CustomModal';
import { ReportDescription } from '../../../Schedule/ScheduleDetails/Components/ReportDescription/ReportDescription';
import CustomSkelton from '../../../../../Components/Skeletons/CustomSkelton';
import CustomAddButton from '../../../../../Components/custom_components/CustomAddButton/CustomAddButton';

const columnStyle = { display: 'flex', gap: '20px', marginBottom: '20px', padding: '10px', width: '100%' };
const renderSkeletonCard = () => (
    <div style={columnStyle}>
        <CustomSkelton
            variant="rounded"
            height={140}
            width="100%"
            animation="wave"
            style={{ borderRadius: '12px', marginRight: '20px' }}
        />
    </div>
);

const ReportAssignmentsViewOnly = ({ reportsData, isLoading,
    handleOpenReportModal, scheduleId,
    isAddReport, isViewReport


}) => {
    const [open, setOpen] = useState(false);
    const [selectedReport, setSelectedReport] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [filteredReports, setFilteredReports] = useState(reportsData);

    const handleCloseModal = () => {
        setOpen(false);
        setSelectedReport(null);
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (!searchText.trim()) {
                setFilteredReports(reportsData);
            } else {
                const query = searchText.toLowerCase();
                const filtered = reportsData?.filter(report =>
                    report.report_name?.toLowerCase().includes(query)
                );
                setFilteredReports(filtered);
            }
        }, 400);
        return () => clearTimeout(timeout);
    }, [searchText, reportsData]);

    return (
        <div className="report-section">
            {/* HEADER */}
            {isLoading ? (
                renderSkeletonCard()
            ) : (
                <div className="report-header-container">
                    <div className="report-header-left">
                        {isAddReport && (
                            <CustomAddButton
                                label="Add Report"
                                onClick={() => handleOpenReportModal(null, scheduleId, null)}
                            />
                        )}
                    </div>

                    <div className="report-header-search">
                        <CustomSearchBar
                            value={searchText}
                            onChange={setSearchText}
                            placeholder="Search by Report name"
                        />
                    </div>
                </div >
            )}

            {/* REPORT CARDS */}
            {isLoading ? (
                <div className="schedule-details-loader-container">
                    {renderSkeletonCard()} {renderSkeletonCard()}
                </div>
            ) : (
                <div className="report-assignment-grid">
                    {filteredReports?.length > 0 ? (
                        filteredReports.map((report, index) => (
                            <div key={index} className="report-card">
                                <span className="report-title">{report?.report_name}</span>
                                <span style={{ color: '#1976d2' }}>{report?.latest_status}</span>

                                <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                                    {isViewReport && <CustomTooltipWithoutRoundBorder title="View">
                                        <span
                                            onClick={() => {
                                                setSelectedReport(report);
                                                setOpen(true);
                                            }}
                                            className="report-status clickable report-view-button"
                                        >
                                            View
                                        </span>
                                    </CustomTooltipWithoutRoundBorder>}
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="no-data-message">No records found</p>
                    )}
                </div>
            )}

            {/* MODAL VIEW */}
            {open && (
                <CustomModal
                    open={open}
                    handleClose={handleCloseModal}
                    title={selectedReport?.report_name}
                    body={
                        <Box className="report-modal-box">
                            <div className="stage-section">
                                {selectedReport?.Process?.map((stage, idx) => (
                                    <div key={idx} className="stage-card">
                                        <div className="stage-header">
                                            <span className="report-stage">
                                                {stage?.Type || `Stage ${idx + 1}`}
                                            </span>
                                        </div>

                                        {Array.isArray(stage?.Result) && stage.Result.length > 0 ? (
                                            stage.Result.map((res, rIdx) => (
                                                <div key={rIdx}>
                                                    {/* Accepted Report Details */}
                                                    {true && (
                                                        <div className="accepted-report-container">
                                                            <h4 className="accepted-report-title">Accepted</h4>
                                                            <div className="accepted-report-card">
                                                                <div className="accepted-report-item">
                                                                    <FaUserTie className="accepted-report-icon" />
                                                                    <span><strong>Assigned by:</strong> {res?.assigned_by || 'N/A'}</span>
                                                                </div>
                                                                <div className="accepted-report-item">
                                                                    <FaCalendarAlt className="accepted-report-icon" />
                                                                    <span><strong>Assigned on:</strong> {res?.assigned_Date || 'N/A'}</span>
                                                                </div>
                                                                <div className="accepted-report-item">
                                                                    <FaUser className="accepted-report-icon" />
                                                                    <span><strong>Accepted by:</strong> {res?.acceptedBy || 'N/A'}</span>
                                                                </div>
                                                                <div className="accepted-report-item">
                                                                    <FaCalendarAlt className="accepted-report-icon" />
                                                                    <span><strong>Accepted on:</strong> {res?.accepted_Date || 'N/A'}</span>
                                                                </div>
                                                                <div className="accepted-report-item">
                                                                    <GrDocumentVerified className="accepted-report-icon" />
                                                                    <span><strong>Submitted by:</strong> {res?.acceptedBy || 'N/A'}</span>
                                                                    <span style={{ marginLeft: '6px' }}><strong>on:</strong> {res?.isComplted_on || 'N/A'}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Description */}
                                                    {stage?.Type_ID !== 4 && (
                                                        <ReportDescription description={res?.description || 'N/A'} />
                                                    )}
                                                </div>
                                            ))
                                        ) : (
                                            <div className="report-detail">
                                                <p className="no-data-message">No records found</p>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </Box>
                    }
                    maxWidth="79%"
                />
            )}
        </div>
    );
};

export default ReportAssignmentsViewOnly;
